import React, { useCallback, useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { supabase } from "../lib/supabase";

const MFA_UPDATED_EVENT = "voras:mfa-updated";

const MfaPendingBanner = () => {
  const [hasMfa, setHasMfa] = useState(null);
  const location = useLocation();

  const evaluate = useCallback(() => {
    const userId = sessionStorage.getItem("User");
    if (!userId) return;

    supabase.auth.mfa
      .listFactors()
      .then(({ data }) => {
        const verified = data?.totp?.some((f) => f.status === "verified");
        setHasMfa(Boolean(verified));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    evaluate();
    window.addEventListener(MFA_UPDATED_EVENT, evaluate);
    return () => window.removeEventListener(MFA_UPDATED_EVENT, evaluate);
  }, [evaluate, location.pathname]);

  if (hasMfa === null || hasMfa) return null;

  const palette = { bg: "#fef9ef", border: "#fde68a", fg: "#92400e", icon: "#d97706" };
  const enProfile = location.pathname === "/profile";

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 20,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: { xs: 2, md: 3 },
        py: 1.25,
        backgroundColor: palette.bg,
        borderBottom: `1px solid ${palette.border}`,
      }}
    >
      <ShieldOutlinedIcon sx={{ color: palette.icon, fontSize: 22, flexShrink: 0 }} />
      <Typography sx={{ flexGrow: 1, fontSize: "0.85rem", fontWeight: 500, color: palette.fg }}>
        La autenticación en dos pasos (2FA) es obligatoria. Configurala para poder seguir usando el sistema.
      </Typography>
      {!enProfile && (
        <Button
          component={RouterLink}
          to="/profile"
          variant="contained"
          disableElevation
          sx={{
            flexShrink: 0,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.8rem",
            borderRadius: "8px",
            px: 2,
            backgroundColor: palette.fg,
            "&:hover": { backgroundColor: palette.icon },
          }}
        >
          Activar 2FA
        </Button>
      )}
    </Box>
  );
};

export { MFA_UPDATED_EVENT };
export default MfaPendingBanner;
